import { Button, Form, Input, message, Radio, Select } from 'antd';
import {
    getMasterSettingsData, FundAccountUpdatePayload, SelectPayload,
    SelectList, createFundAccountMapping, getSourceAppNames, SourceAppNamelist, MstRequest
} from 'api/master';
import { UserPayload } from 'api/profile';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {
    isAdmin: boolean;
    onSubmit: (values: FundAccountUpdatePayload) => Promise<void>;
};

const updatePayload: FundAccountUpdatePayload = {};
const mstRequest: MstRequest = {};
const initPartners: SelectList[] = [];
const inituser: UserPayload = {};

const Addfundaccount = ({ onSubmit }: Props) => {
    const navigate = useNavigate();
    const { Option } = Select;
    const [filter, setFilter] = useState(updatePayload);
    const [form] = Form.useForm<FundAccountUpdatePayload>();
    const [_user, _setUser] = useState(inituser);
    const [statusList, setStatusList] = useState<SelectList[]>(initPartners);
    const [statusId, setStatusId] = useState<number | undefined>();
    const [isSourceUpdate, setSourceUpdate] = useState(false);
    const [sourceAppNames, setSourceAppNames] = useState<SourceAppNamelist[]>([]);


    const location = useLocation();
    let state: any = location.state;
    console.log(state);

    useEffect(() => {
        const statusPayload: SelectPayload = {
            sKey: 'LoanType',
        };
        getMasterSettingsData(statusPayload).then((res) => {
            setStatusList(res.data);
        });
        getSourceAppNames(mstRequest).then((response) => {
            setSourceAppNames(response.data);
        });
    }, []);

    const handleSubmit = useCallback(
        async (values: FundAccountUpdatePayload) => {
            setSourceUpdate(true);
            debugger;
            values.createdBy = sessionStorage.getItem('user')?.toString();
            values.loanType = values.loanType?.toString();
            values.isActive = true;
            values.fundAccMapId = undefined;
            createFundAccountMapping(values)
                .then((_res) => {
                    if (_res.responseCode == '200' && _res.message == 'Data created Succesfully') {
                        message.success('FundAccount is Created Successfully!');
                    }
                    if (
                        _res.responseCode == '200' &&
                        (_res.message == 'Data Already Exists!' || _res.message == 'Some Error Occured!')
                    ) {
                        message.warn('Record is Already Exists!');
                    }
                })
                .finally(() => {
                    form.resetFields();
                    setSourceUpdate(false);
                    navigate('/master/fundaccount');
                });
        },
        [onSubmit, form]
    );

    function handleReset(_e: any) {
        form.resetFields();
        let updatedFilter = { ...filter };
        updatedFilter = updatePayload;
        setFilter(updatedFilter);
        navigate('/master/fundaccount');
    }
    const handleStatusId = (value: number) => {
        form.setFieldValue('loanType', value);
        setStatusId(value);
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <div className="mid-container">
                        <div className="submission-box">
                            <h2>Add FundAccount</h2>
                            <div className="submission-htmlForm">
                                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                                <Form
                                    form={form}
                                    onFinish={handleSubmit}
                                    layout="vertical"
                                    scrollToFirstError
                                    className="standard-forms"
                                    initialValues={{
                                        ['Username']: sessionStorage.getItem('user')?.toString(),
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Loan Type :'}
                                                    name="loanType"
                                                    className="fieldTitle"
                                                    style={{ marginBottom: '20px' }}
                                                    rules={[{ required: true, message: 'Please select a loan type' }]}
                                                >
                                                    <Select
                                                        placeholder="Select"
                                                        size="large"
                                                        value={statusId}
                                                        onChange={handleStatusId}
                                                    >
                                                        {statusList.map((status) => (
                                                            <Option key={status.sKey} value={status.sVlue}>{status.sText}</Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Payment Purpose :'}
                                                    name="paymentPurpose"
                                                    className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please select a Payment Purpose' }]}
                                                >
                                                    <Select placeholder="Select" size="large">
                                                        <Option value="Fees">Fees</Option>
                                                        <Option value="Foreclosure">Foreclosure</Option>
                                                        <Option value="Overdue">Overdue</Option>
                                                        <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                                                        <Option value="PartPayment">PartPayment</Option>
                                                        <Option value="ADVANCEEMI">Advance EMI</Option>
                                                        <Option value="OtherCharges">Other Charges</Option>
                                                        <Option value="Post Disbursement">Post disbursement</Option>
                                                        <Option value="VAS">VAS</Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Source Application Name:'}
                                                    name="sourceId"
                                                    className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please select a Source Application Name' }]}
                                                >

                                                    <Select placeholder="Select" size="large">
                                                        {sourceAppNames.map((app) => (
                                                            <Option key={app.sourceId} value={app.sourceId}>
                                                                {app.sourceApplicationName}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Receipt Service :'}
                                                    name="receiptService"
                                                    className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please select a Receipt Service' }]}

                                                >
                                                    <Select placeholder="Select" size="large">
                                                        <Option value="AllocatePayment">AllocatePayment</Option>
                                                        <Option value="EARLYSETTLEMENT">EARLYSETTLEMENT</Option>
                                                        <Option value="FEEPAYMENT">FEEPAYMENT</Option>
                                                        <Option value="IMD">IMD</Option>
                                                        <Option value="MANUALPAYMENT">MANUALPAYMENT</Option>
                                                        <Option value="PARTIALSETTLEMENT">PARTIALSETTLEMENT</Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Merchant ID :'} name="merchantId" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a merchant Id' }]}>
                                                    <Input placeholder={'Merchant ID'} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Funding Account :'} name="fundingAccount" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a Funding Account' }]}>
                                                    <Input placeholder={'Funding Account'} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'RazorPay Key :'} name="razorPayKey" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a RazorPay Key' }]}>
                                                    <Input placeholder={'RazorPay Key'} />
                                                </Form.Item>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'RazorPay Secret :'} name="razorPaySecret" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a RazorPay Secret' }]}>
                                                    <Input placeholder={'RazorPay Secret'} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">


                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Charges Bear By :'} name="chargesBearBy" className="fieldTitle">
                                                    <Radio.Group onChange={(e) => form.setFieldsValue({ chargesBearBy: e.target.value })}>
                                                        <Radio value={'A'}>Avanse</Radio>
                                                        <Radio value={'C'}>Company</Radio>
                                                    </Radio.Group>
                                                </Form.Item>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row"></div>
                                    <div className="payment-button">
                                        <Button
                                            className="proceed-btn"
                                            id="btnSubmit"
                                            htmlType="submit"
                                            size="small"
                                            disabled={isSourceUpdate ? true : false}
                                        >
                                            SAVE
                                        </Button>

                                        <Button
                                            id="btnClear"
                                            className="proceed-btn"
                                            size="small"
                                            style={{ marginLeft: '10px' }}
                                            onClick={handleReset}
                                        >
                                            BACK
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Addfundaccount;
